import type { StaticImageData } from 'next/image';
import type { ReactNode } from 'react';
import MobileFeatureModal from '../MobileFeatureModal';

type Props = {
  className?: string;
  isOpen: boolean;
  onRequestClose: () => void;
  qrCode: string | StaticImageData;
  subtitleDesktop?: ReactNode;
  subtitleMobile?: ReactNode;
  title: ReactNode;
  variant?: 'navigator' | 'explore';
};

const AppQrCodeModal = ({ className, isOpen, onRequestClose, qrCode, subtitleDesktop, subtitleMobile, title, variant = 'navigator' }: Props) => {
  return (
    <MobileFeatureModal
      className={className}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      qrCodeImgSrc={qrCode}
      subtitleMobile={subtitleMobile}
      subtitleDesktop={subtitleDesktop}
      title={title}
      variant={variant}
    />
  );
};

export default AppQrCodeModal;
